// Rückruf ohne Lead (Calls, I-05/T36): Die Telefonie legt jeden Anruf an einem Lead ab. Gehört eine Nummer noch zu keinem Lead,
// legt dieses Formular unter der Zeile den Lead aus der Nummer an (Firma Pflicht, Kontakt optional) und ruft danach sofort an.
// Der Eintrag selbst bleibt wie in Close ohne Lead; erledigt wird er mit dem Rückruf wie bei den anderen Calls.
import { useState } from "react";
import { leadNeuApi } from "../../api/leadsNeu";
import { useAuth } from "../../auth/AuthContext";
import { useMeta } from "../../daten/meta";
import { Icon } from "../Icon";
import { useMeldung } from "../Meldungen";

interface Props {
  nummer: string;
  /** Die Nummer so, wie sie in der Zeile steht (mit Land) */
  anzeige: string;
  /** Der Lead steht: jetzt zurückrufen */
  onAngelegt: (lead: { id: string; name: string }, kontaktName: string | null) => void;
}

export function LeadAusNummer({ nummer, anzeige, onAngelegt }: Props) {
  const [offen, setOffen] = useState(false);
  const [firma, setFirma] = useState("");
  const [kontakt, setKontakt] = useState("");
  const [laeuft, setLaeuft] = useState(false);
  const { nutzer } = useAuth();
  const { meta } = useMeta();
  const meldung = useMeldung();

  if (!offen) {
    return (
      <button type="button" className="knopf knopf--klein knopf--primaer" onClick={() => setOffen(true)}>
        <Icon name="plus" groesse={13} /> Lead anlegen und zurückrufen
      </button>
    );
  }

  const anlegen = async () => {
    const name = firma.trim();
    if (!name) {
      meldung.zeige("fehler", "Bitte eine Firma oder einen Namen eingeben.");
      return;
    }
    setLaeuft(true);
    try {
      // Neue Leads aus eingehenden Anrufen beginnen wie alle anderen im Status „Erstkontakt“ (wenn es ihn gibt)
      const status = meta?.lead_statuses.find((s) => s.label.trim().toLowerCase() === "erstkontakt");
      const bearbeiterFeld = meta?.custom_fields.lead.find((f) => f.type === "user" && f.name.trim().toLowerCase() === "bearbeiter");
      const r = await leadNeuApi.anlegen({
        firma: name,
        kontakt_name: kontakt.trim() || null,
        telefon: nummer,
        status_id: status?.id ?? null,
        bearbeiter_id: bearbeiterFeld ? (nutzer?.close_user_id ?? null) : null,
      });
      meldung.ok(`Lead „${r.lead.display_name || r.lead.name || name}“ angelegt.`);
      onAngelegt({ id: r.lead.id, name: r.lead.display_name || r.lead.name || name }, kontakt.trim() || null);
    } catch (e) {
      meldung.fehler(e, "Lead nicht angelegt");
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <form
      className="lead-aus-nummer"
      onSubmit={(e) => {
        e.preventDefault();
        void anlegen();
      }}
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          e.stopPropagation();
          setOffen(false);
        }
      }}
    >
      <span className="leise lead-aus-nummer__nummer">Neuer Lead mit {anzeige}</span>
      <input className="eingabe eingabe--klein" placeholder="Firma oder Name" aria-label="Firma oder Name" value={firma} autoFocus onChange={(e) => setFirma(e.target.value)} />
      <input className="eingabe eingabe--klein" placeholder="Ansprechpartner (optional)" aria-label="Ansprechpartner" value={kontakt} onChange={(e) => setKontakt(e.target.value)} />
      <button type="submit" className="knopf knopf--klein knopf--primaer" disabled={laeuft || !firma.trim()}>
        <Icon name="telefon" groesse={13} /> {laeuft ? "Legt an …" : "Anlegen und anrufen"}
      </button>
      <button type="button" className="knopf knopf--klein knopf--leise" onClick={() => setOffen(false)}>
        Abbrechen
      </button>
    </form>
  );
}
